export enum Color {
  PURPLE = '#7c7df8',
  BLACK = '#000000',
  WHITE = '#ffffff',
  SAND = '#ece7e4',
  GREEN = '#95d8b8',
  GREEN_LIGHT = '#e0f4eb',
  PURPLE_LIGHT = '#d9dcef',
  TRANSPARENT = 'transparent',
}

export enum Layout {
  HORIZONTAL,
  VERTICAL,
}

export enum Direction {
  UP = 'up',
  DOWN = 'down',
  LEFT = 'left',
  RIGHT = 'right',
}

export enum ChevronType {
  FULL = 'full',
  DEFAULT = 'default',
}

export enum Position {
  BOTTOM,
  TOP,
}
